import { Injectable } from '@angular/core';
import { IMessage, RxStomp, RxStompState } from '@stomp/rx-stomp';
import { rxStompConfig } from './rxStompConfig';
import {
	MessageSystemDTO,
	MessageSystemNavigationDTO,
	OutputMessageDTO,
} from '../../shared/models/models.model';
import { ListenerService } from '../listener/listener.service';
import { AuthService } from '../auth/auth.service';
import { BehaviorSubject } from 'rxjs';

export enum RxStompEventAction {
	'INITIAL',
	'LOGIN',
	'LOGOUT',
}
interface RxStompEvent {
	action?: RxStompEventAction;
}

@Injectable({
	providedIn: 'root',
})
export class RxStompService extends RxStomp {
	private _event: BehaviorSubject<RxStompEvent> = new BehaviorSubject<RxStompEvent>({});
	private _authService: AuthService;

	constructor(public listenerService: ListenerService) {
		super();
		this._event.subscribe((rxStompEvent: RxStompEvent) => {
			switch (rxStompEvent.action) {
				case RxStompEventAction.INITIAL: {
					this.instance();
					break;
				}
				case RxStompEventAction.LOGIN: {
					this.doLogin();
					break;
				}
				case RxStompEventAction.LOGOUT: {
					this.doLogout();
					break;
				}
			}
		});
	}

	public authService(authService: AuthService): void {
		this._authService = authService;
	}

	public doEvent(rxStompEventAction: RxStompEventAction): void {
		console.log(RxStompEventAction[rxStompEventAction]);
		this._event.next({ action: rxStompEventAction });
	}

	private instance(): void {
		this.connectionState$.subscribe((state) => {
			// state is an Enum (Integer), RxStompState[state] is the corresponding string
			// console.log(RxStompState[state]);
			if (state == RxStompState.OPEN) {
				this.onRegister();
			}
		});
		this._watch();
	}

	private doLogin(): void {
		const token = this._authService.accessToken;
		if (token === '') {
			setTimeout(() => {
				this.doLogin();
			}, 100);
			return;
		}
		const url = rxStompConfig.brokerURL;
		rxStompConfig.brokerURL = rxStompConfig.brokerURL.replace('{token}', token);
		super.configure(rxStompConfig);
		super.activate();
	}

	private doLogout(): void {
		console.log('doLogout...');
		this.destroy();
	}

	private destroy(): void {
		super.deactivate().then();
	}

	private _watch(): void {
		this.watch('/topic/system').subscribe((message: IMessage) => {
			const data: OutputMessageDTO = JSON.parse(message.body);
			const _message: MessageSystemDTO = new MessageSystemDTO(data);
			this.listenerService.messageSystemEmit(_message);
		});

		this.watch('/topic/system/navigation').subscribe((message: IMessage) => {
			const data: OutputMessageDTO = JSON.parse(message.body);
			const _message: MessageSystemNavigationDTO = new MessageSystemNavigationDTO(data);
			this.listenerService.messageSystemNavigationEmit(_message);
		});
	}

	private onRegister() {
		const message = {};
		this.onSendMessage('/ws/register', message);
	}

	private onSendMessage(destination, message) {
		message = { ...message, token: this._authService.accessToken };
		this.publish({
			destination,
			body: JSON.stringify(message),
		});
	}
}
